export const PUBLISHED_PRACTITIONER_NOTE_QUERY_KEY =
  'published-practitioner-note';
export const PRACTITIONER_NOTE_QUERY_KEY = 'practitioner-note';
export const CAN_WRITE_PRACTITIONER_NOTE_QUERY_KEY =
  'can-write-practitioner-note';
